import { render, staticRenderFns } from "./NotEnoughItem.vue?vue&type=template&id=6ad9e8be&scoped=true&"
import script from "./NotEnoughItem.vue?vue&type=script&lang=js&"
export * from "./NotEnoughItem.vue?vue&type=script&lang=js&"
import style0 from "./NotEnoughItem.vue?vue&type=style&index=0&id=6ad9e8be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad9e8be",
  null
  
)

export default component.exports